import React, { useEffect, useState } from "react";
import "../../styles/projectStyles/Summary.css";
import Footer from "../HeaderFooter/Footer";

const getFromLocalStorage = (key, defaultValue) => {
  const storedValue = localStorage.getItem(key);
  try {
    const parsedValue = JSON.parse(storedValue);
    return Array.isArray(defaultValue) && !Array.isArray(parsedValue)
      ? defaultValue
      : parsedValue ?? defaultValue;
  } catch {
    return defaultValue;
  }
};

const setToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

const Summary = () => {
  const [projectDescription, setProjectDescription] = useState(() =>
    getFromLocalStorage("projectDescription", {})
  );
  const [tasksAndTeam, setTasksAndTeam] = useState(() =>
    getFromLocalStorage("selectedTasks", [])
  );
  const [projectDates, setProjectDates] = useState(() =>
    getFromLocalStorage("dateRanges", {})
  );

  console.log("DATE ", projectDates);
  const [files, setFiles] = useState(() =>
    getFromLocalStorage("uploadedFiles", [])
  );

  // Update localStorage whenever any of these states change
  useEffect(() => {
    console.log("projectDescription", projectDescription);
    setToLocalStorage("projectDescription", projectDescription);
  }, [projectDescription]);

  useEffect(() => {
    console.log("selectedTasks", tasksAndTeam);
    setToLocalStorage("selectedTasks", tasksAndTeam);
  }, [tasksAndTeam]);

  useEffect(() => {
    console.log("dateRanges", JSON.stringify(projectDates));
    setToLocalStorage("dateRanges", projectDates);
  }, [projectDates]);

  useEffect(() => {
    console.log("uploadedFiles", files);
    setToLocalStorage("uploadedFiles", files);
  }, [files]);

  return (
    <div className="summary-container">
      <div className="summaryScreen">
        <div className="summary-header-container">
          <h3 className="summary">Summary</h3>
          <div className="summ-container">
            {/* Project Description */}
            <div className="description-container">
              <h3 className="summary-title">Project Description</h3>
              <div className="details-container">
                <div className="details-wrapper">
                  <table className="details-table">
                    <thead>
                      <tr>
                        <th>House Details</th>
                        <th>Contact Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>Address</strong>
                          <br />
                          {projectDescription.address || "Not provided"}
                        </td>
                        <td>
                          <strong>Postal Code</strong>
                          <br />
                          {projectDescription.housecode || "Not provided"}
                        </td>
                        <td>
                          <strong>Phone Number</strong>
                          <br />
                          {projectDescription.phoneNumber || "Not provided"}
                        </td>
                        <td>
                          <strong>Email Address</strong>
                          <br />
                          {projectDescription.email || "Not provided"}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="2">
                          <h3 className="overview">Project Overview</h3>
                          <p>
                            {projectDescription.overview ||
                              "No overview provided"}
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Task and Dates */}
            <div className="taskanddates-container">
              <h3 className="summary-title">Task and Dates</h3>
              <div className="details-container">
                <table className="project">
                  <tbody>
                    {tasksAndTeam.map((task, index) => (
                      <React.Fragment key={index}>
                        <tr className="task-title">
                          <td colSpan="2">{task.name || task.taskname}</td>
                        </tr>
                        <tr>
                          <td className="task-details">
                            
                              {(task.subtasklist || []).map((subtask) => (
                                <li key={subtask.value}>{subtask.label}</li>
                              ))}
                           
                          </td>
                          <td className="team-data">
                            {(task.employeelist || []).map(
                              (member, memberIdx) => (
                                <>
                                  {memberIdx !== 0 && (
                                    <hr className="horizontal-line" />
                                  )}
                                  <div className="teams" key={memberIdx}>
                                    <div className="employee-name">
                                      {member.label}
                                    </div>

                                    <div className="employee-date">
                                      {(
                                        projectDates[task.taskid]?.[
                                          memberIdx
                                        ] || []
                                      ).length > 0 ? (
                                        projectDates[task.taskid][
                                          memberIdx
                                        ].map((dateRange, rangeIdx) => (
                                          <div key={rangeIdx} className="date-range" >
                                            <span>
                                              {dateRange.startDate
                                                ? new Date(
                                                    dateRange.startDate
                                                  ).toLocaleDateString()
                                                : "No Start Date"}
                                              {"      "}
                                              to{"        "}
                                              {dateRange.endDate
                                                ? new Date(
                                                    dateRange.endDate
                                                  ).toLocaleDateString()
                                                : "No End Date"}
                                            </span>

                                            <span style={{ paddingLeft: "5em" }} >
                                              {dateRange.startTime ||
                                                "Time is not Selected"}
                                            </span>
                                          </div>
                                        ))
                                      ) : (
                                        <span>No dates or times selected</span>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="2">
                            <hr className="horizontal-line" />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Additional Details */}
            <div className="additionaldetails-container">
              <h3 className="summary-title">Additional Details</h3>

              <div className="additionaldetails">
                <h3 className="attach">Attachments</h3>

                <div className="file-list">
                  {files.length > 0 ? (
                    files.map((file, index) => (
                      <div key={index} className="file-item">
                        <img
                          src={file.image || "images/doc.svg"}
                          alt={`${file.name} preview`}
                          className="file-preview"
                        />
                        <span className="file-name">{file.name}</span>
                        <span className="file-size">{file.size}</span>
                      </div>
                    ))
                  ) : (
                    <p>No files uploaded</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Summary;
